import { createAction, createSlice } from '@reduxjs/toolkit';

export const showGlobalLoader = createAction('global/showGlobalLoader');
export const hideGlobalLoader = createAction('global/hideGlobalLoader');

export const TOGGLE_LOADER = 'global/showLoader';

const globalSlice = createSlice({
  name: 'global',
  initialState: {
    loaded: true,
  },
  reducers: {
    showLoader: (state, action) => {
      const { status } = action.payload;
      state.loaded = status;
    },
    showGlobalLoader: (state) => {
      state.loaded = false;
    },
    hideGlobalLoader: (state) => {
      state.loaded = true;
    },
  },
});

export function showLoader(status) {
  return { type: TOGGLE_LOADER, payload: { status: !status } };
}

const { reducer } = globalSlice;

export default reducer;
